// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Button } from "@/components/ui/button";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import HospitalInquiryModal from "@/components/HospitalInquiryModal";
// import { Building2, ArrowRight, CheckCircle, Award, Globe } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// function PartnerCard({ partner }) {
//   // Generate initials from partner name
//   const getInitials = (name) => {
//     return name.split(' ').map(word => word[0]).join('').slice(0, 2).toUpperCase();
//   };

//   return (
//     <Card className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden hover:shadow-lg transition-all group" data-testid={`partner-card-${partner.id}`}>
//       <div className="h-48 bg-gradient-to-br from-orange-50 to-slate-50 flex items-center justify-center p-8 border-b border-slate-100">
//         {partner.logo_url ? (
//           <img 
//             src={partner.logo_url} 
//             alt={partner.name} 
//             className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform"
//             onError={(e) => {
//               e.target.style.display = 'none';
//               e.target.nextSibling.style.display = 'flex';
//             }}
//           />
//         ) : null}
//         <div className={`${partner.logo_url ? 'hidden' : 'flex'} flex-col items-center justify-center`}>
//           <div className="w-20 h-20 rounded-2xl bg-orange-600 flex items-center justify-center mb-2">
//             <span className="text-2xl font-bold text-white">{getInitials(partner.name)}</span>
//           </div>
//           <span className="text-slate-500 text-sm font-medium">{partner.name}</span>
//         </div>
//       </div>
//       <div className="p-6">
//         <h3 className="font-heading text-xl font-semibold text-slate-900 mb-2">{partner.name}</h3>
//         {partner.description && (
//           <p className="text-slate-500 text-sm mb-4 line-clamp-2">{partner.description}</p>
//         )}
//         <HospitalInquiryModal
//           hospitalName={partner.name}
//           trigger={
//             <Button variant="outline" className="text-orange-600 border-orange-600 hover:bg-orange-50 text-sm">
//               Inquire About This Hospital <ArrowRight className="ml-1 h-3.5 w-3.5" />
//             </Button>
//           }
//         />
//       </div>
//     </Card>
//   );
// }

// function PartnerLogosSlider({ partners }) {
//   // Generate initials from partner name
//   const getInitials = (name) => {
//     return name.split(' ').map(word => word[0]).join('').slice(0, 2).toUpperCase();
//   };

//   return (
//     <section className="py-12 bg-slate-50 overflow-hidden" data-testid="partner-logos-slider">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-8">
//           <p className="text-slate-500 text-sm uppercase tracking-wider font-medium">Trusted by Leading Healthcare Institutions</p>
//         </div>
//         <div className="relative">
//           <div className="flex items-center justify-center gap-12 flex-wrap">
//             {partners.map((partner) => (
//               <div key={partner.id} className="flex flex-col items-center justify-center gap-2 hover:opacity-100 transition-all">
//                 {partner.logo_url ? (
//                   <div className="h-16 w-40 flex items-center justify-center grayscale hover:grayscale-0 opacity-70 hover:opacity-100">
//                     <img 
//                       src={partner.logo_url} 
//                       alt={partner.name}
//                       className="max-h-full max-w-full object-contain"
//                       onError={(e) => {
//                         e.target.parentElement.innerHTML = `<div class="w-12 h-12 rounded-lg bg-orange-600 flex items-center justify-center"><span class="text-lg font-bold text-white">${getInitials(partner.name)}</span></div>`;
//                       }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="w-14 h-14 rounded-xl bg-orange-600 flex items-center justify-center">
//                     <span className="text-lg font-bold text-white">{getInitials(partner.name)}</span>
//                   </div>
//                 )}
//                 <span className="text-slate-500 text-xs font-medium">{partner.name}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function WhyPartnerWithUs() {
//   const benefits = [
//     { icon: Award, title: "Accredited Excellence", desc: "All partner hospitals are JCI/NABH accredited with international quality standards" },
//     { icon: Globe, title: "Global Recognition", desc: "Our partners serve patients from 50+ countries with multilingual support" },
//     { icon: CheckCircle, title: "Verified Outcomes", desc: "Track record of successful outcomes across all medical specialties" },
//   ];

//   return (
//     <section className="py-16" data-testid="why-partner-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Why Our Partner Network Stands Out</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet and select only the best healthcare institutions to ensure world-class care for our patients</p>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {benefits.map((item, i) => (
//             <div key={i} className="text-center">
//               <div className="w-16 h-16 rounded-2xl bg-orange-100 flex items-center justify-center mx-auto mb-4">
//                 <item.icon className="h-8 w-8 text-orange-600" />
//               </div>
//               <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{item.title}</h3>
//               <p className="text-slate-500 text-sm">{item.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default function PartnersPage() {
//   const [partners, setPartners] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     axios.get(`${API}/partners`)
//       .then(res => setPartners(res.data))
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-96">
//         <div className="loading-bar" />
//       </div>
//     );
//   }

//   return (
//     <div data-testid="partners-page">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-b from-orange-50 to-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
//               Our Network
//             </Badge>
//             <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">
//               Trusted <span className="text-orange-600">Hospital Partners</span>
//             </h1>
//             <p className="text-lg text-slate-600 max-w-2xl mx-auto">
//               We partner with India's most renowned hospitals and healthcare institutions to provide you with the best medical care
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Partner Logos Slider */}
//       <PartnerLogosSlider partners={partners} />

//       {/* Why Partner With Us */}
//       <WhyPartnerWithUs />

//       {/* Partner Cards */}
//       <section className="py-16 bg-slate-50" data-testid="partner-cards-section">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Our Hospital Partners</h2>
//             <p className="text-slate-500">Explore our network of world-class healthcare institutions</p>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {partners.map((partner) => (
//               <PartnerCard key={partner.id} partner={partner} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center">
//             <h2 className="font-heading text-3xl font-semibold text-white mb-4">
//               Get Treatment at Our Partner Hospitals
//             </h2>
//             <p className="text-slate-300 max-w-xl mx-auto mb-8">
//               Experience world-class healthcare at India's finest institutions. Get a free consultation and treatment plan today.
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="partners-cta-btn">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />
//               <Link to="/hospitals">
//                 <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base">
//                   View Hospital Details
//                 </Button>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>
      
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import HospitalInquiryModal from "@/components/HospitalInquiryModal";
import { Building2, ArrowRight, CheckCircle, Award, Globe, Search, X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function PartnerCard({ partner }) {
  const getInitials = (name) => {
    return name.split(' ').map(word => word[0]).join('').slice(0, 2).toUpperCase();
  };

  return (
    <Card className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden hover:shadow-lg transition-all group" data-testid={`partner-card-${partner.id}`}>
      <div className="h-48 bg-gradient-to-br from-orange-50 to-slate-50 flex items-center justify-center p-8 border-b border-slate-100">
        {partner.logo_url ? (
          <img 
            src={partner.logo_url} 
            alt={partner.name} 
            className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className={`${partner.logo_url ? 'hidden' : 'flex'} flex-col items-center justify-center`}>
          <div className="w-20 h-20 rounded-2xl bg-orange-600 flex items-center justify-center mb-2">
            <span className="text-2xl font-bold text-white">{getInitials(partner.name)}</span>
          </div>
          <span className="text-slate-500 text-sm font-medium">{partner.name}</span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-heading text-xl font-semibold text-slate-900 mb-2">{partner.name}</h3>
        {partner.description && (
          <p className="text-slate-500 text-sm mb-4 line-clamp-2">{partner.description}</p>
        )}
        <HospitalInquiryModal
          hospitalName={partner.name}
          trigger={
            <Button variant="outline" className="text-orange-600 border-orange-600 hover:bg-orange-50 text-sm">
              Inquire About This Hospital <ArrowRight className="ml-1 h-3.5 w-3.5" />
            </Button>
          }
        />
      </div>
    </Card>
  );
}

function PartnerLogosSlider({ partners }) {
  const getInitials = (name) => {
    return name.split(' ').map(word => word[0]).join('').slice(0, 2).toUpperCase();
  };

  return (
    <section className="py-12 bg-slate-50 overflow-hidden" data-testid="partner-logos-slider">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-slate-500 text-sm uppercase tracking-wider font-medium">Trusted by Leading Healthcare Institutions</p>
        </div>
        <div className="relative">
          <div className="flex items-center justify-center gap-12 flex-wrap">
            {partners.map((partner) => (
              <div key={partner.id} className="flex flex-col items-center justify-center gap-2 hover:opacity-100 transition-all">
                {partner.logo_url ? (
                  <div className="h-16 w-40 flex items-center justify-center grayscale hover:grayscale-0 opacity-70 hover:opacity-100">
                    <img 
                      src={partner.logo_url} 
                      alt={partner.name}
                      className="max-h-full max-w-full object-contain"
                      onError={(e) => {
                        e.target.parentElement.innerHTML = `<div class="w-12 h-12 rounded-lg bg-orange-600 flex items-center justify-center"><span class="text-lg font-bold text-white">${getInitials(partner.name)}</span></div>`;
                      }}
                    />
                  </div>
                ) : (
                  <div className="w-14 h-14 rounded-xl bg-orange-600 flex items-center justify-center">
                    <span className="text-lg font-bold text-white">{getInitials(partner.name)}</span>
                  </div>
                )}
                <span className="text-slate-500 text-xs font-medium">{partner.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function WhyPartnerWithUs() {
  const benefits = [
    { icon: Award, title: "Accredited Excellence", desc: "All partner hospitals are JCI/NABH accredited with international quality standards" },
    { icon: Globe, title: "Global Recognition", desc: "Our partners serve patients from 50+ countries with multilingual support" },
    { icon: CheckCircle, title: "Verified Outcomes", desc: "Track record of successful outcomes across all medical specialties" },
  ];

  return (
    <section className="py-16" data-testid="why-partner-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Why Our Partner Network Stands Out</h2>
          <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet and select only the best healthcare institutions to ensure world-class care for our patients</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((item, i) => (
            <div key={i} className="text-center">
              <div className="w-16 h-16 rounded-2xl bg-orange-100 flex items-center justify-center mx-auto mb-4">
                <item.icon className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{item.title}</h3>
              <p className="text-slate-500 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── Search Bar Component ──────────────────────────────────────────────────────
function PartnerSearchBar({ searchQuery, setSearchQuery, totalCount, filteredCount }) {
  return (
    <div className="mb-10" data-testid="partner-search-bar">
      {/* Search Input */}
      <div className="max-w-xl mx-auto relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
        <Input
          type="text"
          placeholder="Search hospitals by name..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-11 pr-11 py-5 text-sm rounded-full border border-slate-200 bg-white shadow-sm focus:border-orange-400 focus:ring-orange-400 placeholder:text-slate-400"
          data-testid="partner-search-input"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
            data-testid="partner-search-clear"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Results Count */}
      {searchQuery && (
        <p className="text-center text-sm text-slate-500 mt-3" data-testid="partner-search-results-count">
          Showing{" "}
          <span className="font-semibold text-slate-700">{filteredCount}</span>{" "}
          of{" "}
          <span className="font-semibold text-slate-700">{totalCount}</span>{" "}
          hospital{totalCount !== 1 ? "s" : ""} for{" "}
          <span className="text-orange-600 font-medium">"{searchQuery}"</span>
        </p>
      )}
    </div>
  );
}

// ─── Empty State ───────────────────────────────────────────────────────────────
function NoPartnersFound({ searchQuery, onClear }) {
  return (
    <div className="col-span-full flex flex-col items-center justify-center py-20 text-center" data-testid="partner-no-results">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
        <Search className="h-7 w-7 text-slate-400" />
      </div>
      <h3 className="font-heading text-lg font-semibold text-slate-700 mb-1">
        No hospitals found
      </h3>
      <p className="text-slate-400 text-sm mb-5 max-w-xs">
        No results for{" "}
        <span className="text-orange-500 font-medium">"{searchQuery}"</span>.
        Try a different name.
      </p>
      <Button
        variant="outline"
        onClick={onClear}
        className="rounded-full border-slate-200 text-slate-600 hover:border-orange-400 hover:text-orange-600 text-sm"
      >
        Clear Search
      </Button>
    </div>
  );
}

// ─── Main Page ─────────────────────────────────────────────────────────────────
export default function PartnersPage() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios.get(`${API}/partners`)
      .then(res => setPartners(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  // ── Filter partners based on search query ──
  const filteredPartners = partners.filter((partner) =>
    partner.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (partner.description && partner.description.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="loading-bar" />
      </div>
    );
  }

  return (
    <div data-testid="partners-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-orange-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
              Our Network
            </Badge>
            <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">
              Trusted <span className="text-orange-600">Hospital Partners</span>
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              We partner with India's most renowned hospitals and healthcare institutions to provide you with the best medical care
            </p>
          </div>
        </div>
      </section>

      {/* Partner Logos Slider */}
      <PartnerLogosSlider partners={partners} />

      {/* Why Partner With Us */}
      <WhyPartnerWithUs />

      {/* Partner Cards */}
      <section className="py-16 bg-slate-50" data-testid="partner-cards-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Section Header */}
          <div className="text-center mb-10">
            <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Our Hospital Partners</h2>
            <p className="text-slate-500">Explore our network of world-class healthcare institutions</p>
          </div>

          {/* ── Search Bar ── */}
          <PartnerSearchBar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            totalCount={partners.length}
            filteredCount={filteredPartners.length}
          />

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredPartners.length > 0 ? (
              filteredPartners.map((partner) => (
                <PartnerCard key={partner.id} partner={partner} />
              ))
            ) : (
              <NoPartnersFound
                searchQuery={searchQuery}
                onClear={() => setSearchQuery("")}
              />
            )}
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center">
            <h2 className="font-heading text-3xl font-semibold text-white mb-4">
              Get Treatment at Our Partner Hospitals
            </h2>
            <p className="text-slate-300 max-w-xl mx-auto mb-8">
              Experience world-class healthcare at India's finest institutions. Get a free consultation and treatment plan today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <ConsultationModal
                trigger={
                  <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="partners-cta-btn">
                    Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                }
              />
              <Link to="/hospitals">
                <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base">
                  View Hospital Details
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}